// Generated by CoffeeScript 2.7.0
var Manipulator;

import Delegator from './delegator.js';

export default Manipulator = class Manipulator extends Delegator {
  prepend(node) {
    this.delegator.node.insertAdjacentHTML('afterbegin', node);
    return this.delegator.node;
  }

  append(node) {
    this.delegator.node.insertAdjacentHTML('beforeend', node);
    return this.delegator.node;
  }

  replaceWith(node) {
    var element;
    element = DomMaster.wrap(node);
    this.delegator.node.parentNode.replaceChild(element.node, this.delegator.node);
    this.delegator.node = element.node;
    return this.delegator.node;
  }

  html(node) {
    this.delegator.node.innerHTML = node instanceof DomMaster ? node.withContainer ? node.node.innerHTML : node.node.outerHTML : node;
    return this.delegator.node;
  }

  remove() {
    if (this.delegator.isPresent()) {
      return this.delegator.node.parentNode.removeChild(this.delegator.node);
    }
  }

  hide() {
    return this.delegator.node.setAttribute('hidden', true);
  }

  show() {
    return this.delegator.node.removeAttribute('hidden');
  }

  toggle(display) {
    if (_.isBoolean(display)) {
      if (display) {
        return this.show();
      } else {
        return this.hide();
      }
    } else {
      if (this.delegator.node.getAttribute('hidden') === null) {
        return this.hide();
      } else {
        return this.show();
      }
    }
  }

};
